module.exports = __webpack_public_path__ + "img/symbol-one-seventh-right.959e576f.png";